var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{staticClass:"progress-bar"},[_c('grid-item',{attrs:{"size":"1/1"}},[_c('ul',{staticClass:"progressbar"},_vm._l((_vm.countQuestions),function(index){return _c('li',{key:index,class:{ active: index <= _vm.questionIndex }})}),0)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }